<template>
  <!-- ── Créer un examen ── -->
  <Toast />
  <div class="exam-create-wrap" v-if="showListEleves === false">
    <div class="exam-create-header">
      <span class="exam-eyebrow">Examen conduite</span>
      <h1 class="exam-title">Créer un examen</h1>
    </div>

    <div class="exam-create-fields">
      <div class="field-group">
        <label class="field-label">Lieu</label>
        <select class="field-select" v-model="lieu">
          <option value="">Sélectionner un lieu</option>
          <template v-for="l in lieux" :key="l.id">
            <option :value="l.id">{{ l.nom }}{{ lieuxAttente[l.id] ? ' — ' + lieuxAttente[l.id] + ' en attente' : '' }}</option>
          </template>
        </select>
      </div>

      <div class="field-group">
        <label class="field-label">Boîte</label>
        <select class="field-select" v-model="boite">
          <option value="">Sélectionner une boîte</option>
          <template v-for="b in boites" :key="b.id">
            <option :value="b.id">{{ b.label }}</option>
          </template>
        </select>
      </div>

      <div class="field-group">
        <label class="field-label">Nb. de places</label>
        <input class="field-input" type="number" v-model="nbPlace" placeholder="ex : 4">
      </div>

      <button v-if="!loadingBtn" class="btn btn-green" @click="createExam">
        <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M12 5v14M5 12h14"/></svg>
        Créer
      </button>
      <button v-else class="btn btn-green" @click="createExam" disabled>
        <i class="fa fa-spinner fa-spin"></i> Créer
      </button>
    </div>
  </div>

  <!-- ── Liste élèves + sous-états ── -->
  <div v-if="showListEleves === true">

    <!-- État A : liste -->
    <template v-if="selectedItem === null && this.showCancelExam === false">
      <div class="exam-banner" v-if="exam">
        <div class="exam-banner-head" v-if="showTab === 'true'">
          <button class="exam-banner-close" @click="$emit('close')" title="Fermer">✕</button>
          <h1 class="exam-banner-title">Examen conduite</h1>
        </div>
        <div class="exam-banner-info">
          <div class="exam-info-row">
            <span class="exam-info-label">Date :</span>
            <span class="exam-info-value">{{ examDate }}</span>
          </div>
          <div class="exam-info-row">
            <span class="exam-info-label">Heure :</span>
            <span class="exam-info-value">{{ examHeure }}</span>
          </div>
          <div class="exam-info-row">
            <span class="exam-info-label">Lieu :</span>
            <span class="exam-info-value">{{ exam.lieu.nom }}</span>
          </div>
          <div class="exam-info-row">
            <span class="exam-info-label">Boîte :</span>
            <span class="exam-info-value">{{ exam.boite.nom }}</span>
          </div>
          <div class="exam-info-row">
            <span class="exam-info-label">Moniteur :</span>
            <span class="exam-info-value">{{ exam.mono.nom }}</span>
          </div>
          <div class="exam-info-row">
            <span class="exam-info-label">Places :</span>
            <span class="exam-info-value">{{ exam.nbPlace }}</span>
          </div>
        </div>
        <div class="exam-banner-actions" :class="{ 'exam-banner-actions--plain': showTab !== 'true' }">
          <button v-if="showTab === 'true' && this.planningResaE.event !== undefined && this.showSelect === true" class="btn btn-secondary" @click="this.getElevesByExam(0, false); this.showSelect = false;">
            <svg width="13" height="13" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M18 6L6 18M6 6l12 12"/></svg>
            Elèves non sélectionnés
          </button>
          <button v-if="showTab === 'true' && this.planningResaE.event !== undefined && this.showSelect === false" class="btn btn-secondary" @click="this.getElevesByExam(0, true); this.showSelect = true;">
            <svg width="13" height="13" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M18 6L6 18M6 6l12 12"/></svg>
            Elèves électionnés
          </button>
          <button v-if="showTab === 'true' && this.planningResaE.event !== undefined" class="btn btn-danger-soft" @click="showCancelExam = true;">
            <svg width="13" height="13" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M18 6L6 18M6 6l12 12"/></svg>
            Annuler exam
          </button>
          <button v-if="showShortList === false" class="btn btn-secondary" @click="openShortList">
            <svg width="13" height="13" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M4 6h16M8 12h8M11 18h2"/></svg>
            Short list
          </button>
          <button v-if="showShortList === true" class="btn btn-primary" @click="closeShortList">
            <svg width="13" height="13" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M4 6h16M4 12h16M4 18h16"/></svg>
            Retour : {{ showSelectAvantShortList ? 'Elèves électionnés' : 'Elèves non sélectionnés' }}
          </button>
        </div>
      </div>

      <div class="field-group" style="margin:0 20px 16px;">
        <label class="field-label">Rechercher un élève</label>
        <input class="field-input" type="text" v-model="rechercheEleve" @input="onRechercheEleveChange" placeholder="Nom ou prénom...">
      </div>

      <div class="field-group" style="margin:0 20px 16px;">
        <label class="field-label">Filtrer par lieu souhaité</label>
        <select class="field-select" v-model="filtreLieu" @change="onFiltreLieuChange">
          <option value="">Tous les lieux</option>
          <template v-for="l in lieux" :key="l.id">
            <option :value="l.id">{{ l.nom }}</option>
          </template>
        </select>
      </div>

      <div class="table-wrap">
        <DataTable :value="eleves" tableStyle="width: 100%" v-model:selection="selectedItem" @click="onSelected" :rows="10" selectionMode="single" :rowClass="shortlistRowClass">
          <Column field="" header="Sélec">
            <template #body="slotProps">
              <template v-if="slotProps.data.selec === true">
                <input class="row-checkbox" type="checkbox" @change="cbxChanges(slotProps.data)" :name="slotProps.data.id" :id="slotProps.data.id" :value="slotProps.data.id" checked>
              </template>
              <template v-else>
                <input class="row-checkbox" type="checkbox" @change="cbxChanges(slotProps.data)" :name="slotProps.data.id" :id="slotProps.data.id" :value="slotProps.data.id">
              </template>
            </template>
          </Column>
          <Column field="demande" header="Date demande"></Column>
          <Column field="source" header="Source"></Column>
          <Column field="mono" header="Mono"></Column>
          <Column field="eleve" header="Élève">
            <template #body="slotProps">
              <span v-if="slotProps.data.shortlisted" class="shortlist-star" title="Dans la short list">★</span>
              {{ slotProps.data.eleve }}
            </template>
          </Column>
          <Column field="hRestant" header="H rest."></Column>
          <Column field="solde" header="Solde"></Column>
          <Column field="statusPassage" header="Statut"></Column>
          <Column field="lieux" header="Lieux souhaités">
            <template #body="slotProps">
              {{ lieuxLabel(slotProps.data.lieux) }}
            </template>
          </Column>
        </DataTable>
        <Paginator
          :rows="10"
          :totalRecords="countEleves"
          @page="onPaginate"
        ></Paginator>
      </div>
    </template>

    <!-- État B : annuler l'examen -->
    <template v-else-if="this.showCancelExam === true">
      <div class="exam-banner" v-if="exam">
        <div class="exam-banner-head" v-if="showTab === 'true'">
          <button class="exam-banner-close" @click="showCancelExam = false;" title="Fermer">✕</button>
          <span class="exam-banner-eyebrow">Action critique</span>
          <h1 class="exam-banner-title">Annuler l'examen</h1>
        </div>
        <div class="exam-banner-info">
          <div class="exam-info-row">
            <span class="exam-info-label">Date :</span>
            <span class="exam-info-value">{{ examDate }}</span>
          </div>
          <div class="exam-info-row">
            <span class="exam-info-label">Heure :</span>
            <span class="exam-info-value">{{ examHeure }}</span>
          </div>
          <div class="exam-info-row">
            <span class="exam-info-label">Lieu :</span>
            <span class="exam-info-value">{{ exam.lieu.nom }}</span>
          </div>
          <div class="exam-info-row">
            <span class="exam-info-label">Boîte :</span>
            <span class="exam-info-value">{{ exam.boite.nom }}</span>
          </div>
          <div class="exam-info-row">
            <span class="exam-info-label">Moniteur :</span>
            <span class="exam-info-value">{{ exam.mono.nom }}</span>
          </div>
          <div class="exam-info-row">
            <span class="exam-info-label">Places :</span>
            <span class="exam-info-value">{{ exam.nbPlace }}</span>
          </div>
        </div>
      </div>

      <div class="alert-card alert-card-red">
        <svg width="15" height="15" fill="none" viewBox="0 0 24 24" style="flex-shrink:0;color:#ef4444;"><path stroke="currentColor" stroke-width="2" d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="12" y1="17" x2="12.01" y2="17" stroke="currentColor" stroke-width="2"/></svg>
        <p>Cette action est irréversible. L'examen sera annulé pour tous les élèves inscrits.</p>
      </div>

      <div class="field-group" style="margin:0 20px 16px;">
        <label class="field-label">Annulé par</label>
        <select class="field-select" name="cancelBy" id="cancelBy" v-model="cancelExam">
          <option value="">Sélectionner…</option>
          <option value="agence">Agence</option>
          <option value="préfecture">Préfecture</option>
        </select>
      </div>

      <div class="choice-row">
        <button class="btn btn-secondary choice-btn" @click="showCancelExam = false;">
          <svg width="13" height="13" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M15 18l-6-6 6-6"/></svg>
          Retour
        </button>
        <button v-if="!loadingBtn" class="btn btn-danger choice-btn" @click="cancelAnExam">
          <svg width="13" height="13" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M18 6L6 18M6 6l12 12"/></svg>
          Confirmer l'annulation
        </button>
        <button v-else class="btn btn-danger choice-btn" @click="cancelAnExam" disabled>
          <i class="fa fa-spinner fa-spin"></i> Confirmer l'annulation
        </button>
      </div>
    </template>

    <!-- État C : élève sélectionné -->
    <template v-else>
      <div class="exam-banner" v-if="exam">
        <div class="exam-banner-head">
          <button class="exam-banner-close" @click="cancelEleveSelec" title="Fermer">✕</button>
          <span class="exam-banner-eyebrow">Élève sélectionné</span>
          <h1 class="exam-banner-title">{{ this.selectedItem.eleve }}</h1>
        </div>
        <div class="exam-banner-info">
          <div class="exam-info-row">
            <span class="exam-info-label">Date :</span>
            <span class="exam-info-value">{{ examDate }}</span>
          </div>
          <div class="exam-info-row">
            <span class="exam-info-label">Heure :</span>
            <span class="exam-info-value">{{ examHeure }}</span>
          </div>
          <div class="exam-info-row">
            <span class="exam-info-label">Lieu :</span>
            <span class="exam-info-value">{{ exam.lieu.nom }}</span>
          </div>
          <div class="exam-info-row">
            <span class="exam-info-label">Boîte :</span>
            <span class="exam-info-value">{{ exam.boite.nom }}</span>
          </div>
          <div class="exam-info-row">
            <span class="exam-info-label">Moniteur :</span>
            <span class="exam-info-value">{{ exam.mono.nom }}</span>
          </div>
          <div class="exam-info-row">
            <span class="exam-info-label">Places :</span>
            <span class="exam-info-value">{{ exam.nbPlace }}</span>
          </div>
        </div>
      </div>

      <!-- Saisir score -->
      <div class="score-form" v-if="showScoreOrCancel === false">
        <div class="score-fields-row">
          <div class="field-group" style="flex:1;">
            <label class="field-label">Résultat examen</label>
            <input class="field-input" type="number" name="score" id="score" v-model="score" placeholder="ex : 28">
          </div>
          <div class="field-group checkbox-group">
            <label class="field-label">Éliminatoire</label>
            <div class="checkbox-pill">
              <input type="checkbox" class="row-checkbox" name="elimi" id="elimi" v-model="elim">
              <span>Oui</span>
            </div>
          </div>
        </div>

        <template v-if="score !== null && score < 20 || elim === true">
          <div class="field-group">
            <label class="field-label" for="dateAtt">Date d'attente</label>
            <input class="field-input" type="date" name="dateAtt" id="dateAtt" v-model="dateAtt">
          </div>
        </template>

        <div class="choice-row" style="margin:8px 0 0;">
          <button class="btn btn-danger-soft choice-btn" @click="setAbsEleve">
            <svg width="13" height="13" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M18 6L6 18M6 6l12 12"/></svg>
            ABS
          </button>
          <button v-if="!loadingBtn" class="btn btn-green choice-btn" @click="updatePassage">
            <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M5 13l4 4L19 7"/></svg>
            Valider
          </button>
          <button v-else class="btn btn-green choice-btn" @click="updatePassage" disabled>
            <i class="fa fa-spinner fa-spin"></i> Valider
          </button>
        </div>
      </div>

      <!-- Annulation élève (ABS) -->
      <div class="cancel-form" v-if="showScoreOrCancel === true">
        <div class="field-group">
          <label class="field-label" for="dateAtt">Date d'attente</label>
          <input class="field-input" type="date" name="dateAtt" id="dateAtt" v-model="dateAtt">
        </div>

        <div class="choice-row" style="margin:8px 0 0;">
          <button class="btn btn-secondary choice-btn" @click="this.showScoreOrCancel = false; this.cancel = '';">
            <svg width="13" height="13" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M15 18l-6-6 6-6"/></svg>
            Retour
          </button>
          <button v-if="!loadingBtn" class="btn btn-danger choice-btn" @click="updatePassage">
            <svg width="13" height="13" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M18 6L6 18M6 6l12 12"/></svg>
            Confirmer l'annulation
          </button>
          <button v-else class="btn btn-danger choice-btn" @click="updatePassage" disabled>
            <i class="fa fa-spinner fa-spin"></i> Confirmer l'annulation
          </button>
        </div>
      </div>

    </template>
  </div>
</template>

<script>

import moment from "moment";
import { useToast } from "primevue/usetoast";

export default {

  props: [
    "planningResaE",
    "showTab"
  ],

  emits: ["close"],

  components: {

  },

  data() {
    return {
      lieux : [],
      boites : [],
      lieu : "",
      boite : "",
      nbPlace : "",
      exam : null,
      showListEleves : false,
      eleves : [],
      countEleves : 0,
      countExamEleve : 0,
      selectedItem : null,
      showScoreOrCancel : false,
      score : null,
      elim : false,
      cancel : "",
      dateCancel : null,
      dateAtt : null,
      showShortList : false,
      showCancelExam : false,
      cancelExam : "",
      loadingBtn : false,
      showSelect: true,
      showSelectAvantShortList: true,
      filtreLieu: "",
      rechercheEleve: "",
      rechercheEleveTimeout: null,
      lieuxAttente: {},
      toast: useToast(),
    };
  },

  mounted() {
    this.getLieuBoite();
    this.getLieuxAttente();
    if(this.showTab !== "false"){
      this.showListEleves = true;
      this.getAnExam();
    }

  },

  watch: {
    // Le composant reste monté d'un clic à l'autre sur le planning : sans ce watch,
    // cliquer sur un autre examen ne rafraîchissait pas les infos affichées.
    planningResaE(newVal, oldVal) {
      if (this.showTab !== 'true' || !newVal || !newVal.event) return;
      const newId = newVal.event._def.publicId;
      const oldId = oldVal && oldVal.event ? oldVal.event._def.publicId : undefined;
      if (newId !== oldId) {
        this.selectedItem = null;
        this.showCancelExam = false;
        this.showScoreOrCancel = false;
        this.showShortList = false;
        this.showSelect = true;
        this.cancelExam = "";
        this.score = null;
        this.elim = false;
        this.cancel = "";
        this.dateAtt = null;
        this.filtreLieu = "";
        this.rechercheEleve = "";
        this.getAnExam();
      }
    },
    boite(){
      if(this.showListEleves === false){
        this.getLieuxAttente();
      }
    },
  },

  computed: {
    examDate() {
      return this.exam ? moment(this.exam.start).format("DD/MM/YYYY") : "";
    },
    examHeure() {
      if (!this.exam) return "";
      return moment(this.exam.start).format("HH:mm") + " — " + moment(this.exam.end).format("HH:mm");
    },
  },

  methods: {

    getAllInscritsExam(){
      const headers = { Authorization: "Bearer " + this.$store.state.token };
      const urlOffset = (offset) => "/demande/by/exam/eleves/" + this.$store.state.user.agence.id + "/" + offset + "/" + this.exam.id + "/true";
      return window.api
        .get(urlOffset(0), { headers })
        .then((response) => {
          const total = response.data.count;
          const inscrits = response.data.examenDemande;
          if(total <= inscrits.length){
            return inscrits;
          }
          const promises = [];
          for(let offset = inscrits.length; offset < total; offset += 10){
            promises.push(
              window.api.get(urlOffset(offset), { headers }).then((r) => r.data.examenDemande)
            );
          }
          return Promise.all(promises).then((pages) => inscrits.concat(...pages));
        });
    },

    cancelAnExam(){
      this.loadingBtn = true;
      if(this.cancelExam === ""){
        alert("Veuillez choisir l'instigateur de l'annulation");
        this.loadingBtn = false;
      }else{
        if (window.confirm("Êtes-vous sûr de vouloir annuler cet examen ?")) {
          // Récupérer les élèves inscrits AVANT d'annuler (le cancel peut changer leur statut côté serveur)
          this.getAllInscritsExam()
            .then(inscrits => {
              return window.api
                .post(
                  "/cancel/exam/" + this.planningResaE["event"]["_def"]["publicId"],
                  { cancel: this.cancelExam },
                  { headers: { Authorization: "Bearer " + this.$store.state.token } }
                )
                .then(() => {
                  this.loadingBtn = false;
                  this.toast.add({
                    severity: "success",
                    summary: "Votre action a bien été prise en compte !",
                    life: 3000,
                  });
                  const { date, heure } = this.getExamDateTime();
                  const promises = inscrits.map(e =>
                    window.api.post(
                      "/sendMailExamen",
                      { type: "examen conduite annule agence", email: e.email, date, heure },
                      { headers: { Authorization: "Bearer " + this.$store.state.token } }
                    ).catch(err => console.log(err))
                  );
                  return Promise.all(promises);
                });
            })
            .then(() => window.location.reload())
            .catch((error) => {
              console.log(error);
              this.loadingBtn = false;
              window.location.reload();
            });
        }else{
          this.loadingBtn = false;
        }
      }
    },

    buildFiltresEleves(){
      const params = {};
      if(this.filtreLieu !== ""){
        params.lieu = this.filtreLieu;
      }
      if(this.rechercheEleve !== ""){
        params.recherche = this.rechercheEleve;
      }
      return params;
    },

    shortListEleves(offset){
      window.api
        .get("/short/demande/by/exam/eleves/" + this.$store.state.user.agence.id + "/" + offset + "/" + this.exam.id, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
          params: this.buildFiltresEleves(),
         })
        .then((response) => {
          this.eleves = response.data.examenDemande;
          this.countEleves = response.data.count;
          this.showShortList = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    openShortList(){
      this.showSelectAvantShortList = this.showSelect;
      this.shortListEleves(0);
    },

    closeShortList(){
      this.showSelect = this.showSelectAvantShortList;
      this.getElevesByExam(0, this.showSelect);
    },

    cancelEleveSelec(){
      this.selectedItem = null;
      this.showScoreOrCancel = false;
      this.cancel = "";
      this.getElevesByExam(0, this.showSelect);
    },

    onSelected(){
      if(this.showTab !== 'true'){
        // Dans le flux de création (pas le split page sur un event existant), cliquer sur une
        // ligne ne doit rien ouvrir : la saisie de résultat se fait depuis le split page.
        this.selectedItem = null;
      }else if(this.selectedItem.selec !== true){
        this.selectedItem = null;
      }else{
        window.api
          .get(
            "/passage/exam/eleve/info/"+this.selectedItem.id+"/"+this.planningResaE["event"]["_def"]["publicId"]+"/",
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            }
          )
          .then((response) => {
            this.selectedItem.passage = response.data.passageInfo;
            this.score = response.data.passageInfo.score;
            this.elim = response.data.passageInfo.eli;
            this.dateAtt = response.data.passageInfo.dateAtt;
            if(response.data.passageInfo.cancelBy !== null){
              this.cancel = response.data.passageInfo.cancelBy;
              this.dateCancel = response.data.passageInfo.cancelDate;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },  

    getLieuBoite(){
      window.api
        .get(
          "/boite/lieu/exam/",
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then((response) => {
          this.lieux = response.data.lieux;
          this.boites = response.data.boites;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getLieuxAttente(){
      window.api
        .get(
          "/lieux/eleves/attente/exam/" + this.$store.state.user.agence.id,
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
            params: this.boite !== "" ? { boite: this.boite } : {},
          }
        )
        .then((response) => {
          this.lieuxAttente = response.data.counts;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getAnExam(){
      window.api
        .get(
          "/get/exam/" + this.planningResaE["event"]["_def"]["publicId"],
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then((response) => {
            this.exam = response.data.exam;
            this.showListEleves = true;
            this.getElevesByExam(0, this.showSelect);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    setAbsEleve(){
      this.cancel = "eleve";
      this.showScoreOrCancel = true;
    },

    updatePassage(){
      this.loadingBtn = true;
      if(this.showScoreOrCancel === false){
        if(this.score === null || this.score === ""){
          alert("Veuillez saisir le résultat");
          this.loadingBtn = false;
        }else if(this.score < 20 || this.elim === true){
          if(this.dateAtt === null){
            alert("Veuillez saisir la date d'attente");
            this.loadingBtn = false;
          }else{
            if (window.confirm("Êtes-vous sûr de vouloir saisir ce score ?")){
              window.api
                .post(
                  "/set/passage/exam/" + this.selectedItem.passage.idp + "/add",
                  {
                    score: this.score,
                    eliminatoire: this.elim,
                    dateAtt: this.dateAtt,
                  },
                  {
                    headers: {
                      Authorization: "Bearer " + this.$store.state.token,
                    },
                  }
                )
                .then(() => {
                  this.loadingBtn = false;
                  this.toast.add({
                      severity: "success",
                      summary: "Votre action a bien été prise en compte !",
                      life: 3000,
                    });
                  const { date } = this.getExamDateTime();
                  this.sendMailExamen("examen conduite echoue", this.selectedItem.passage.email, { date, score: this.score, eliminatoire: this.elim });
                })
                .catch((error) => {
                  console.log(error);
                });
            }else{
              this.loadingBtn = false;
            }
          }
        }else{
          if (window.confirm("Êtes-vous sûr de vouloir saisir ce score ?")){
            window.api
              .post(
                "/set/passage/exam/" + this.selectedItem.passage.idp + "/add",
                {
                  score: this.score,
                  eliminatoire: this.elim,
                  dateAtt: this.dateAtt,
                },
                {
                  headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                  },
                }
              )
              .then(() => {
                this.loadingBtn = false;
                this.toast.add({
                    severity: "success",
                    summary: "Votre action a bien été prise en compte !",
                    life: 3000,
                  });
                this.sendMailExamen("examen conduite reussi", this.selectedItem.passage.email, { score: this.score });
              })
              .catch((error) => {
                console.log(error);
              });
          }else{
            this.loadingBtn = false;
          }
        }
      }else{
        if(this.cancel === ""){
          alert("Veuillez saisir la partie annulant l'examen pour l'élève");
          this.loadingBtn = false;
        }else if(this.cancel === "eleve" && this.dateAtt === null || this.dateAtt === ""){
          alert("Veuillez saisir la date d'attente");
          this.loadingBtn = false;
        }else{
          if (window.confirm("Êtes-vous sûr de vouloir annuler la participation de cet élève à l'examen ?")){
            window.api
              .post(
                "/set/passage/exam/" + this.selectedItem.passage.idp + "/cancel",
                {
                  cancelBy: this.cancel,
                  dateAtt: this.dateAtt,
                },
                {
                  headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                  },
                }
              )
              .then(() => {
                this.loadingBtn = false;
                this.toast.add({
                    severity: "success",
                    summary: "Votre action a bien été prise en compte !",
                    life: 3000,
                  });
                const { date, heure } = this.getExamDateTime();
                const email = this.selectedItem.passage.email;
                if (this.cancel === 'eleve') {
                  this.sendMailExamen("examen conduite annule eleve", email, { date, heure, dateAttente: this.dateAtt });
                } else {
                  this.sendMailExamen("examen conduite annule agence", email, { date, heure });
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }else{
            this.loadingBtn = false;
          }
        }
      }
    },

    createExam(){
      this.loadingBtn = true;
      if(this.lieu === ""){
        alert("Veuillez saisir un lieu d'examen");
        this.loadingBtn = false;
      }else if(this.boite === ""){
        alert("Veuillez saisir la boite pour l'examen");
        this.loadingBtn = false;
      }else if(this.nbPlace === "" || this.nbPlace === 0){
        alert("Veuillez saisir le nombre de place dispo pour l'examen");
        this.loadingBtn = false;
      }else{
        window.api
          .post(
            "/set/exam/",
            {
              start: moment(this.planningResaE.startStr).format("YYYY-MM-DDTHH:mm:ss"),
              end: moment(this.planningResaE.endStr).format("YYYY-MM-DDTHH:mm:ss"),
              idMono: this.planningResaE["resource"]["_resource"]["id"],
              nbPlace : this.nbPlace,
              lieu: this.lieu,
              boite: this.boite,
              agence: this.$store.state.user.agence.id
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            }
          )
          .then((response) => {
            this.exam = response.data.exam;
            this.showListEleves = true;
            this.showSelect = false;
            this.getElevesByExam(0, false);
            this.loadingBtn = false;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    getElevesByExam(offset, showSelect){
      window.api
        .get("/demande/by/exam/eleves/" + this.$store.state.user.agence.id + "/" + offset + "/" + this.exam.id + "/" + showSelect, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
          params: this.buildFiltresEleves(),
         })
        .then((response) => {
          this.eleves = response.data.examenDemande;
          this.countEleves = response.data.count;
          this.showShortList = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    onFiltreLieuChange(){
      if(this.showShortList === true){
        this.shortListEleves(0);
      }else{
        this.getElevesByExam(0, this.showSelect);
      }
    },

    onRechercheEleveChange(){
      if(this.rechercheEleveTimeout){
        clearTimeout(this.rechercheEleveTimeout);
      }
      this.rechercheEleveTimeout = setTimeout(() => {
        if(this.showShortList === true){
          this.shortListEleves(0);
        }else{
          this.getElevesByExam(0, this.showSelect);
        }
      }, 300);
    },

    lieuxLabel(lieuxIds){
      if(!lieuxIds || lieuxIds.length === 0){
        return '—';
      }
      return lieuxIds
        .map((id) => this.lieux.find((l) => l.id == id)?.nom)
        .filter((nom) => !!nom)
        .join(', ') || '—';
    },

    shortlistRowClass(data){
      return data.shortlisted ? 'row-shortlisted' : '';
    },

    sendMailExamen(type, email, extra = {}) {
      window.api
        .post(
          "/sendMailExamen",
          { type, email, ...extra },
          { headers: { Authorization: "Bearer " + this.$store.state.token } }
        )
        .catch(error => console.log(error));
    },

    getExamDateTime() {
      const start = this.planningResaE.event
        ? this.planningResaE.event.start
        : new Date(this.planningResaE.startStr);
      const end = this.exam?.end
        ? this.exam.end
        : (this.planningResaE.event ? this.planningResaE.event.end : new Date(this.planningResaE.endStr));
      return {
        date: moment(start).format("DD/MM/YYYY"),
        heure: moment(start).format("HH:mm"),
        heureFin: moment(end).format("HH:mm"),
      };
    },

    onPaginate(e) {
        let offset = e.first;
        if(this.showShortList === true){
          this.shortListEleves(offset);
        }else{
          this.getElevesByExam(offset, this.showSelect);
        }
    },


    cbxChanges(eleve){
      let cbxEleve = document.getElementById(eleve.id);

      if(cbxEleve.checked){
        this.addEleveToExam(eleve);
      }else{
        this.deleteEleveFromExam(eleve);
      }
      
    },

    addEleveToExam(eleve){
      if(this.countExamEleve < this.exam.nbPlace){
        window.api
          .post(
            "/set/exam/eleve",
            {
              eleve: eleve.id,
              exam: this.exam.id,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            }
          )
          .then(() => {
            eleve.selec = true;
            const { date, heure, heureFin } = this.getExamDateTime();
            const lieuNom = this.exam?.lieu?.nom || this.lieux.find(l => l.id === this.lieu)?.nom || '';
            this.sendMailExamen("examen conduite reserve", eleve.email, { date, heure: heure + ' - ' + heureFin, lieu: lieuNom });
          })
          .catch((error) => {
            console.log(error);
          });
      }else{
        alert("Vous avez atteint la limite d'élèves pour cet examen.")
      }

    },

    deleteEleveFromExam(eleve){
        window.api
        .delete("/exam/eleve/" + eleve.id + "/" + this.exam.id, {
            headers: {
            Authorization: "Bearer " + this.$store.state.token,
            },
        })
        .then(() => {
          eleve.selec = false;
        })
        .catch((error) => {
            console.log("ERRR::", error.response.data);
            alert("Il est impossible de supprimer cet élève")
        });
    }

  },
};
</script>

<style scoped>

/* ── Élèves de la short list : mis en avant dans le tableau ── */
:deep(tr.row-shortlisted) {
  background-color: #fff8e1 !important;
}
:deep(tr.row-shortlisted:hover) {
  background-color: #fff1c2 !important;
}
.shortlist-star {
  color: #f5a623;
  margin-right: 4px;
}

/* ── Typographie & base ── */
.exam-eyebrow {
  display: block;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .1em;
  color: #94a3b8;
  margin-bottom: 4px;
}

.exam-title {
  font-size: 22px;
  font-weight: 400;
  color: #1a1f2e;
  letter-spacing: -.3px;
  line-height: 1.25;
  margin: 0;
}

/* ── Panel header ── */
.panel-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 20px 20px 16px;
  border-bottom: 1px solid #e2e8f0;
  background: linear-gradient(135deg, #f8fafc 0%, #fff 100%);
  margin-bottom: 20px;
}

.panel-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

/* ── Bannière examen (style aligné sur les mails) ── */
.exam-banner {
  border-radius: 8px;
  overflow: hidden;
  margin: 20px 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}

.exam-banner-head {
  position: relative;
  background-color: #1a73e8;
  padding: 20px 24px;
  text-align: center;
}

.exam-banner-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 6px;
  background: #ef4444;
  color: #fff;
  font-size: 13px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.exam-banner-close:hover {
  background: #dc2626;
}

.exam-banner-eyebrow {
  display: block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .1em;
  color: #d0e4ff;
  margin-bottom: 4px;
}

.exam-banner-title {
  margin: 0;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: 0.3px;
  color: #ffffff;
}

.exam-banner-info {
  background-color: #f0f4ff;
  padding: 16px 24px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px 32px;
}

.exam-info-row {
  display: flex;
  align-items: baseline;
  gap: 8px;
  min-width: 180px;
}

.exam-info-label {
  font-size: 13px;
  color: #777777;
}

.exam-info-value {
  font-size: 13px;
  color: #333333;
  font-weight: 700;
}

.exam-banner-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 16px 24px;
  background-color: #f0f4ff;
}

.exam-banner-actions--plain {
  background-color: transparent;
}

/* ── Créer examen ── */
.exam-create-wrap {
  padding: 20px;
}

.exam-create-header {
  margin-bottom: 20px;
}

.exam-create-fields {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* ── Champs ── */
.field-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.field-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: #94a3b8;
}

.field-select {
  width: 100%;
  padding: 9px 32px 9px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 13px;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E") no-repeat right 10px center;
  -webkit-appearance: none;
  color: #1a1f2e;
  cursor: pointer;
  outline: none;
  transition: border-color .15s, box-shadow .15s;
}
.field-select:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59,130,246,.08);
}

.field-input {
  width: 100%;
  padding: 9px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 13px;
  color: #1a1f2e;
  background: #fff;
  outline: none;
  transition: border-color .15s, box-shadow .15s;
}
.field-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59,130,246,.08);
}
.field-input::placeholder {
  color: #94a3b8;
}

/* ── Boutons ── */
.btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all .15s;
  white-space: nowrap;
  text-decoration: none;
}
.btn:disabled {
  opacity: .6;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

.btn-primary { background: #3b82f6; color: #fff; }
.btn-primary:hover:not(:disabled) { background: #2563eb; transform: translateY(-1px); box-shadow: 0 4px 12px rgba(59,130,246,.3); }

.btn-green { background: #1a9e6e; color: #fff; }
.btn-green:hover:not(:disabled) { background: #168a5f; transform: translateY(-1px); box-shadow: 0 4px 12px rgba(26,158,110,.3); }

.btn-danger { background: #ef4444; color: #fff; }
.btn-danger:hover:not(:disabled) { background: #dc2626; transform: translateY(-1px); box-shadow: 0 4px 12px rgba(239,68,68,.3); }

.btn-danger-soft { background: #fee2e2; color: #ef4444; border: 1px solid #fca5a5; }
.btn-danger-soft:hover:not(:disabled) { background: #ef4444; color: #fff; }

.btn-secondary { background: #f4f6f9; color: #64748b; border: 1px solid #e2e8f0; }
.btn-secondary:hover:not(:disabled) { background: #fff; color: #1a1f2e; border-color: #94a3b8; }

/* Icon-only round button */
.btn-icon {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #f4f6f9;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  transition: all .12s;
  flex-shrink: 0;
}
.btn-icon-danger:hover { background: #fee2e2; color: #ef4444; border-color: #fca5a5; }

/* ── Table ── */
.table-wrap {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0,0,0,.06), 0 1px 2px rgba(0,0,0,.04);
}

.row-checkbox {
  width: 15px;
  height: 15px;
  accent-color: #3b82f6;
  cursor: pointer;
}

/* ── Alert card ── */
.alert-card {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 10px;
  margin: 0 20px 16px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
}

.alert-card-red {
  background: #fee2e2;
  border: 1px solid #fca5a5;
  color: #7f1d1d;
}

/* ── Boutons en ligne ── */
.btn-row {
  display: flex;
  gap: 8px;
  align-items: center;
}

/* ── Choix score / annulation ── */
.choice-row {
  display: flex;
  gap: 12px;
  margin: 20px 20px 0;
}

.choice-btn {
  flex: 1;
  justify-content: center;
  padding: 14px 20px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
}

/* ── Score form ── */
.score-form,
.cancel-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 16px;
  margin: 0 20px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}

.score-fields-row {
  display: flex;
  gap: 12px;
  align-items: flex-end;
}

.checkbox-group {
  flex-shrink: 0;
}

.checkbox-pill {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  transition: all .12s;
  font-size: 13px;
  font-weight: 500;
  color: #1a1f2e;
  height: 38px;
}
.checkbox-pill:hover {
  border-color: #3b82f6;
  background: #eff6ff;
}

</style>